export default __webpack_public_path__ + "static/media/date.4abc743f.svg";